/**
 * Converts base64 string to a blob object for downloading
 * */
import { Buffer } from 'buffer';

const convertB64toBlob = (b64Data: string): Blob => {
  // Decode base64 data
  const byteCharacters = atob(b64Data); // atob() is technically deprecated in Nodejs but Buffer.from() doesn't decode properly
  const buffer = new ArrayBuffer(byteCharacters.length);
  const byteArray = new Uint8Array(buffer);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteArray[i] = byteCharacters.charCodeAt(i);
  }

  return new Blob([byteArray], { type: 'application/zip' });
};

/**
 * Triggers a download on the browser for a given blob
 * */
const downloadFile = (date: Date, name: string, blob: Blob) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  const formattedDate = formatDate(new Date(date));
  const formattedName = name.replaceAll(/[\\/@,\s]+/g, '-');
  link.href = url;
  link.download = `${formattedDate}-${formattedName}.zip`;
  link.click();

  setTimeout(() => {
    link?.parentNode?.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 0);
};

const formatDate = (date: Date): string  => {
  const year = date.getFullYear();
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  return `${year}-${month}-${day}`;
}

const toBinaryString = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

/**
 * Converts a file blob to base 64 for axios requests
 * */
const convertFileToB64 = async (file: File): Promise<string> => {
  try {
    return Buffer.from(await toBinaryString(file)).toString('base64');
  } catch (e) {
    console.error(e);
    return '';
  }
};

export { convertB64toBlob, downloadFile, convertFileToB64, toBinaryString };
